import { Layout, SlideoutDecorator, TableRow } from "@mcleod/components";
import { AutogenLayoutSalesCallMultiSelectErrorSlideout } from "./autogen/AutogenLayoutSalesCallMultiSelectErrorSlideout";
import { ModelRow } from "@mcleod/core";

const layoutPath = "lme/general/SalesCallMultiSelectErrorSlideout"

export class SalesCallMultiSelectErrorSlideout extends AutogenLayoutSalesCallMultiSelectErrorSlideout {

    public static async showSlideout(failedRows: TableRow[]) {
        const layout = Layout.getLayout(layoutPath) as SalesCallMultiSelectErrorSlideout;
        const hasFailures = failedRows.length > 0;
        return new SlideoutDecorator({
            title: "Update Error Details",
            layout: layout,
            width: "65%",
            fillVerticalSpace: true,
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                layout.panelFailed.visible = hasFailures;
                if (hasFailures) {
                    layout.tableFailed.displayData(null, failedRows.map(row => row.data), 0);
                    layout.labelFailedCount.text = failedRows.length.toString();
                }
            },
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            }
        });
    }
}